import React from 'react';
import specialImg1 from '../../Assets/Icons/Vector.png';
import specialImg2 from '../../Assets/Icons/Group.png';
import specialImg3 from '../../Assets/Icons/Group 1.png';
import specialImg4 from '../../Assets/Icons/Vector (1).png';
import { Search } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

const specialityData = [
  {
    icon: specialImg1,
    title: "Expertise",
    desc: "With a deep understanding of the real estate market, our team is equipped to provide you with insights and advice tailored to your unique needs.",
  },
  {
    icon: specialImg2,
    title: "Personalized Service",
    desc: "We listen to what you want and need, offering personalized solutions that match your lifestyle and budget.",
  },
  {
    icon: specialImg3,
    title: "Integrity and Transparency",
    desc: "Building trust is at the core of everything we do. We operate with integrity, honesty, and transparency, ensuring you feel confident and informed at every step.",
  },
  {
    icon: specialImg4,
    title: "Innovative Solutions",
    desc: "Leveraging the latest technology and trends, we offer innovative services that enhance your buying experience.",
  },
];

const Speciality = () => {
  const navigate = useNavigate();

  const handleSearchClick = () => {
    navigate("/my-projects", { state: { focusSearch: true } });
  };
  return (
    <>
      <section className="big-house-special-wrapper">
        <div className="big-house-special-header">
          <h2>Building Your Trust, Finding Your Dream Home</h2>
          <p>With over a decade in real estate, Bighouse Realty is dedicated to finding your perfect property match.</p>
        </div>

        <div className="big-house-special-cards">
          {specialityData.map((item, index) => (
            <div className="big-house-special-card" key={index}>
              <img src={item.icon} alt={item.title} className="big-house-special-icon" />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>


        <div className="property-search-bar">
          <h2>Explore Your Properties</h2>
          <div className="search-input-wrapper" onClick={handleSearchClick} style={{ cursor: "pointer" }}>
            <Search className="search-icon" size={20} />
            <input type="text" name="search" id="search" placeholder="Search for location, property type..." />
          </div>
        </div>
      </section>
    </>
  );
};

export default Speciality;
